import { DateRangePicker, RadioButton, Text } from '~/shared/ui'
import { useFilters } from '../../../model'

export function DateFilter() {
  const { filters, setFilters, dateReceivedFilterType, setDateReceivedFilterType } = useFilters()

  return (
    <>
      <div className="flex items-center px-2 py-0.5">
        <RadioButton
          label="Today"
          gutter
          size="small"
          checked={dateReceivedFilterType === 'today'}
          onChange={() => {
            setDateReceivedFilterType('today')
          }}
        />
      </div>
      <div className="flex items-center px-2 py-0.5">
        <RadioButton
          label="Last 7 days"
          gutter
          size="small"
          checked={dateReceivedFilterType === 'last7days'}
          onChange={() => {
            setDateReceivedFilterType('last7days')
          }}
        />
      </div>
      <div>
        <div className="flex items-center px-2 py-0.5">
          <RadioButton
            className="py-1"
            label={
              <div className="flex flex-col">
                <Text appearance="BODY2">Custom Date Range</Text>
                <Text
                  className="text-text-tertiary"
                  appearance="CAPTION"
                >
                  Select up to 7 days
                </Text>
              </div>
            }
            gutter
            size="small"
            checked={dateReceivedFilterType === 'custom'}
            onChange={() => {
              setDateReceivedFilterType('custom')
            }}
          />
        </div>
        {dateReceivedFilterType === 'custom' && (
          <DateRangePicker
            className="p-4"
            value={
              filters.dateFrom && filters.dateTo
                ? {
                    from: filters.dateFrom,
                    to: filters.dateTo,
                  }
                : undefined
            }
            onChange={(dateRange) => {
              setFilters({
                dateFrom: dateRange?.from ?? '',
                dateTo: dateRange?.to ?? '',
              })
            }}
            maxDays={7}
          />
        )}
      </div>
    </>
  )
}
